"use strict";
var MAX_SAFE_INTEGER = 9007199254740991;
var nativeFloor = Math.floor;
function baseRepeat(string, n) {
    var result = '';
    if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
    }
    do {
        if (n % 2) {
            result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
            string += string;
        }
    } while (n);
    return result;
}
module.exports = baseRepeat;
//# sourceMappingURL=_baseRepeat.js.map